import { AddUnitAttachmentToAdvertisingCtrl } from './unit.attachment.add-to-advertising.ajs';
import { DefaultUnits }                       from './default-unit.directive';
import { MarineUnits }                        from './units.marine.directive';
import { MusicInstrumentsUnits }              from './units.music-instruments.directive';
import { UnitCtrl }                           from './unit';
import { UnitsCtrl }                          from './units';
import { UnitsStates }                        from './units.states.ajs';
import { UnitTransactions }                   from './units.unit-transactions.directive';
import { UnitTransactionsCtrl }               from './units.unit-transactions';

angular.module('workshop.units', [])
.controller('AddUnitAttachmentToAdvertisingCtrl', AddUnitAttachmentToAdvertisingCtrl)
.controller('UnitCtrl',             UnitCtrl)
.controller('UnitsCtrl',            UnitsCtrl)
.controller('UnitTransactionsCtrl', UnitTransactionsCtrl)

.directive('defaultUnits',          DefaultUnits)
.directive('marineUnits',           MarineUnits)
.directive('musicInstrumentsUnits', MusicInstrumentsUnits)
.directive('unitTransactions',      UnitTransactions)

.config(UnitsStates);